module.exports = __webpack_public_path__ + "img/3.99ca05c7.jpg";